var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0243 6.17495C10.2586 6.40927 10.2586 6.78917 10.0243 7.02348L6.42431 10.6235C6.19 10.8578 5.8101 10.8578 5.57578 10.6235L1.97579 7.02348C1.74147 6.78917 1.74147 6.40927 1.97579 6.17495C2.2101 5.94064 2.59 5.94064 2.82431 6.17495L5.40005 8.75069L5.40005 1.79922C5.40005 1.46785 5.66868 1.19922 6.00005 1.19922C6.33142 1.19922 6.60005 1.46785 6.60005 1.79922L6.60005 8.75069L9.17579 6.17495C9.4101 5.94064 9.79 5.94064 10.0243 6.17495Z",
    fill: "#374151",
    stroke: "#F04438",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownRed);
export default __webpack_public_path__ + "static/media/icon-arrow-down-red.cbe08490.svg";
export { ForwardRef as ReactComponent };